export default __webpack_public_path__ + "static/1604-09ef3066925837582f925d51c40856b1.gif";